/**
 * Leaving this bundle for the other half of the app (/platform).
 *
 * A full-document navigation, so it lives in one named function: the shell
 * reads as what it means, and a test can see that it happened — jsdom's
 * `window.location` cannot be spied on.
 */
export function leaveFor(url) {
  window.location.replace(url);
}
